export default __webpack_public_path__ + "91384a57c5188bd941818f1f0b61253c.png";